import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Sparkles } from "lucide-react";
import {
  faHome, faCalendar, faUser, faUsers, faNetworkWired, faFilter, faExclamationTriangle,
  faStar, faBolt, faClock, faDownload, faCog, faChartLine, faEnvelope,
  type IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

export const ICON_MAP: Record<string, IconDefinition> = {
  home: faHome,
  calendar: faCalendar,
  user: faUser,
  users: faUsers,
  "network-wired": faNetworkWired,
  filter: faFilter,
  "triangle-alert": faExclamationTriangle,
  star: faStar,
  zap: faBolt,
  clock: faClock,
  download: faDownload,
  settings: faCog,
  "chart-line": faChartLine,
  envelope: faEnvelope,
};

export const MenuIcon = ({ name, className }: { name: string; className?: string }) => {
  if (name === "sparkles") {
    return (
      <span className="inline-flex w-[1.25em] items-center justify-center" aria-hidden>
        <Sparkles className={`size-[1.1em] ${className ?? ""}`} fill="currentColor" />
      </span>
    );
  }
  const icon = ICON_MAP[name];
  if (!icon) return null;
  return <FontAwesomeIcon size="lg" fixedWidth icon={icon} className={className} aria-hidden />;
}
